import Checkbox from "@/common/components/Checkbox";
import { cn } from "@/common/utils/cn";
import { createElement, useCallback } from "react";
import { UseFormSetValue } from "react-hook-form";
import { dashboardFiltersHiddenFilterComponents } from "../../constants/dashboards/dashboardFilters.constant";
import { UpdateDashboardComponentValidationSchema } from "../../schemas/dashboards/dashboardComponent";
import { DashboardFilters, DashboardHiddenFilterProps } from "../../types/dashboards/dashboard.type";
import { DashboardComponentDateFilters } from "../../types/dashboards/dashboardComponent.type";
import { getDashboardFilterLabel } from "../../utils/dashboards/getDashboardFilterLabel";
import DashboardFilterEndDateHiddenFilter from "./filters/EndDate/DashboardFilterEndDateHiddenFilter";
import DashboardFilterStartDateHiddenFilter from "./filters/StartDate/DashboardFilterStartDateHiddenFilter";

interface UpdateDashboardComponentHiddenFilterProps {
  filter: {
    key: string;
    checked: boolean;
    value?: any;
  };
  index: number;
  setValue: UseFormSetValue<UpdateDashboardComponentValidationSchema>;
  watchFilters: {
    key: string;
    checked: boolean;
    value?: any;
  }[];
}

const UpdateDashboardComponentHiddenFilter = ({
  filter,
  index,
  setValue,
  watchFilters,
}: UpdateDashboardComponentHiddenFilterProps) => {
  const filterLabel = getDashboardFilterLabel(filter.key, {
    ignoreDateRange: true,
  });

  const RenderFilter = useCallback(({
    value,
    onChange,
    watchFilters,
  }: DashboardHiddenFilterProps) => {
    let FilterComponent = dashboardFiltersHiddenFilterComponents[filter.key as DashboardFilters];

    if (filter.key === DashboardComponentDateFilters.StartDate) {
      FilterComponent = DashboardFilterStartDateHiddenFilter;
    }

    if (filter.key === DashboardComponentDateFilters.EndDate) {
      FilterComponent = DashboardFilterEndDateHiddenFilter;
    }

    if (!FilterComponent) {
      return null;
    }

    return createElement(FilterComponent, {
      value,
      onChange,
      watchFilters,
    } as unknown as DashboardHiddenFilterProps);
  }, [
    filter.key,
    filter.checked,
    index,
  ]);

  if (!filterLabel) {
    return null;
  }

  return (
    <div
      className={cn(
        'transition-all flex flex-col gap-3',
        filter.checked && 'p-3 bg-white-100 rounded-md'
      )}
    >
      <Checkbox
        label={filterLabel}
        checked={filter.checked}
        onChange={(event) => {
          const checked = event.currentTarget.checked;

          setValue(`filters.${index}.checked`, checked);

          if (!checked) {
            setValue(`filters.${index}.value`, undefined);
          }
        }}
      />

      {filter.checked && (
        <div>
          <RenderFilter
            value={filter.value}
            onChange={(value: any) => {
              setValue(`filters.${index}.value`, value);
            }}
            watchFilters={watchFilters}
          />
        </div>
      )}
    </div>
  );
}

export default UpdateDashboardComponentHiddenFilter;
